// ChatHead.js
import React from 'react';
import { useChat } from './ChatContext';

const ChatHead = () => {
  const { mode, setMode } = useChat();

  return (
    <div className="chat-header">
      <h1 className="header-title">Chat with Your Study Assistant</h1>
      
      <div className="mode-buttons">
        <button 
          className={`mode-button ${mode === 'conversation' ? 'mode-button-active' : 'mode-button-inactive'}`}
          onClick={() => setMode('conversation')}
        >
          Conversation
        </button>
        <button 
          className={`mode-button ${mode === 'passage' ? 'mode-button-active' : 'mode-button-inactive'}`}
          onClick={() => setMode('passage')}
        >
          Passage
        </button>
        <button 
          className={`mode-button ${mode === 'inquiry' ? 'mode-button-active' : 'mode-button-inactive'}`}
          onClick={() => setMode('inquiry')}
        >
          Inquiry
        </button>
      </div>
    </div>
  );
};

export default ChatHead;

